export var jokerFlexAddon = function (age) {
    if (age <= 45) {
        return 3.5;
    }
    return 0;
};
export var nkSFlexAddon = function (age) {
    if (age > 66) {
        // over age 66
        return 0;
    }
    if (age < 22) {
        // under age 22
        return 4.53;
    }
    var priceTable = [
        4.65,
        4.77,
        4.88,
        5.0,
        5.12,
        5.23,
        5.35,
        5.46,
        5.59,
        5.72,
        5.86,
        6.01,
        6.18,
        6.38,
        6.59,
        6.83,
        7.09,
        7.38,
        7.69,
        8.03,
        8.4,
        8.8,
        9.24,
        9.72,
        10.24,
        10.8,
        11.4,
        12.04,
        12.73,
        13.47,
        14.24,
        15.04,
        15.88,
        16.74,
        17.65,
        18.6,
        19.61,
        19.61,
        20.29,
        21.54,
        21.74,
        23.31,
        25.22,
        25.52,
        27.95, // 66
    ];
    return priceTable[Math.min(Math.max(age, 22), 66) - 22];
};
export var sickPayAddOn = function (age, sickDayPayout) {
    if (sickDayPayout === void 0) { sickDayPayout = 100; }
    var sickDaySurchargeForFiveEurosPayoutTable = [
        1.04,
        1.06,
        1.08,
        1.1,
        1.12,
        1.14,
        1.16,
        1.19,
        1.21,
        1.24,
        1.26,
        1.29,
        1.32,
        1.35,
        1.38,
        1.42,
        1.45,
        1.49,
        1.53,
        1.57,
        1.61,
        1.66,
        1.7,
        1.76,
        1.81,
        1.87,
        1.94,
        2.0,
        2.07,
        2.15,
        2.23,
        2.32,
        2.41,
        2.51,
        2.61,
        2.72,
        2.85,
        2.98,
        3.13,
        3.29,
        3.47,
        3.65,
        3.84,
        4.04,
        4.25,
        4.25,
        4.26,
        4.26,
        4.26,
        4.26,
    ];
    var sickDaySurchargeForFiveEurosPayout = sickDaySurchargeForFiveEurosPayoutTable[Math.min(Math.max(age, 15), 64) - 15];
    return (sickDaySurchargeForFiveEurosPayout / 5) * sickDayPayout;
};
export var travelAddOn = function (age) {
    if (age <= 65) {
        return 1.5;
    }
    return 4;
};
export var hiDentalAddon = function (age) {
    var priceTable = [
        7.66,
        20.37,
        20.37,
        20.37,
        20.37,
        10.93,
        11.19,
        11.44,
        11.72,
        12.01,
        12.3,
        12.6,
        12.91,
        13.23,
        13.53,
        13.86,
        14.19,
        14.53,
        14.88,
        15.3,
        15.74,
        16.24,
        16.76,
        17.33,
        17.89,
        18.47,
        19.04,
        19.64,
        20.22,
        20.81,
        21.4,
        22.01,
        22.64,
        23.31,
        24.03,
        24.82,
        25.65,
        26.56,
        27.53,
        28.57,
        29.67,
        30.81,
        32.02,
        33.29,
        34.53,
        35.72,
        36.84,
        37.87,
        38.78,
        39.62,
        40.4,
        41.12,
        41.75,
        42.3,
        42.76,
    ];
    return priceTable[Math.min(Math.max(age, 16), 70) - 16];
};
export var hiDentalPlusAddon = function (age) {
    var priceTable = [
        16.55,
        60.43,
        60.43,
        60.43,
        60.43,
        31.04,
        31.67,
        32.3,
        32.99,
        33.75,
        34.53,
        35.34,
        36.21,
        37.1,
        37.99,
        38.97,
        39.95,
        40.99,
        42.02,
        43.23,
        44.5,
        45.91,
        47.38,
        49.0,
        50.58,
        52.2,
        53.79,
        55.41,
        56.99,
        58.54,
        60.08,
        61.67,
        63.25,
        64.95,
        66.77,
        68.75,
        70.87,
        73.17,
        75.59,
        78.22,
        81.0,
        83.9,
        87.0,
        90.23,
        93.39,
        96.35,
        99.1,
        101.5,
        103.54,
        105.32,
        106.89,
        108.22,
        109.32,
        110.18,
        110.8,
    ];
    return priceTable[Math.min(Math.max(age, 16), 70) - 16];
};
export var addOnPricing = {
    NKSFLEX: nkSFlexAddon,
    FLEX: jokerFlexAddon,
    KT: sickPayAddOn,
    URZ: travelAddOn,
    HD: hiDentalAddon,
    HDL: hiDentalPlusAddon,
};
